










































import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import helper from '@/services/helper.ts';
import { mapGetters, mapState } from 'vuex';
import api from '@/services/api';
import Q from 'q';
import { Prop } from 'vue-property-decorator';
import printerApi from '@/services/printer';

export type ConfirmCallback = () => boolean;

@Component<AdminModal>({
  computed: {
    ...mapState({
      ShowPrinter: 'ShowPrinter',
    }),
  },
})
export default class AdminModal extends Vue {
  public Password: string = '';

  @Prop() protected readonly name!: string;

  protected readonly ShowPrinter!: boolean;

  get canConfirm() {
    return this.Password ? true : false;
  }

  public beforeOpen(event: any) {
    this.Password = event.params || '';
  }

  public async onLogoutClick() {
    await Q.delay(100);

    helper.swalShowLoading();
    var delayPromise = Q.delay(500);
    let resp = await (await api.Logout(this.Password)).getData(true);
    if (!resp) return;

    await delayPromise;
    helper.close();

    this.$store.commit('UnAuthorize');
    this.$modal.hide(this.name);
    if (this.$route.name !== 'Login') {
      this.$router.push({ name: 'Login' });
    }
  }

  async onCancelVoteClick() {
    var confirms = await helper.cancelVote();
    if (!confirms) return;
    this.$modal.hide(this.name);

    if (process.env.VUE_APP_MODE === 'SA') {
      this.$router.push({ name: 'VoterAssign' });
    }
    if (process.env.VUE_APP_MODE === 'WEB') {
      await api.Logout();
      this.$router.push({ name: 'Login' });
    }
    if (process.env.VUE_APP_MODE === 'CS') {
      this.$router.push({ name: 'Start' });
    }
  }

  public async onPrinterLastClick() {
    helper.swalShowLoading();
    var delayPromise = Q.delay(500);

    let apiResult = await (await api.GetLastPrintLines()).getData();
    if (!apiResult) return;

    await delayPromise;
    helper.close();
    if (!apiResult.PrintLines || apiResult.PrintLines.length == 0) {
      helper.swalWarning({ text: 'No lines to print' });
      return;
    }

    if (!printerApi.isBluetoothPrinterConnected()) {
      helper.swalWarning(this.$t('vs.printer.error.noconnection') as string);
      return;
    }
    if (printerApi.isLowOnPaperOrNoConnection()) {
      helper.swalWarning(this.$t('vs.printer.error.lowpaper') as string);
      return;
    }
    printerApi.YayaPrintLines(apiResult.PrintLines);

    await helper.swalSuccess('');
    this.$modal.hide(this.name);
  }

  public async onPrinterSettingsClick() {
    printerApi.showSettingsScreen();
    this.$modal.hide(this.name);
  }
}
